<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { ArrowLeftIcon } from 'vue-feather-icons'

import { eventBus } from '@/vcs/_shared/eventBus'

export default {
  name: 'RemoteControlBar',
  components: { ArrowLeftIcon },
  data: function () {
    return {
      timer: 0
    }
  },
  computed: {
    ...mapGetters({
      cp: 'getCurrentCp',
      deviceId: 'getDeviceId',
      userToken: 'getUserToken',
      fingerprint: 'getFingerprint'
    })
  },
  watch: {
    cp: function (newCp) {
      newCp?.remoteSignOutEvery
        ? this.restartSignOutTimer(this.$cronTimeToSeconds(newCp.remoteSignOutEvery))
        : null
    }
  },
  mounted() {
    // INFO: QR4
    // Both fingerpint and userToken are available
    // in this component because this component
    // is rendered conditionally
    this.subscribeToSignOutChannel(this.fingerprint)
    this.fetchCpWithRemoteData()
    this.addDocumentEventListener()
    this.addEventBusListener()
  },
  beforeDestroy() {
    clearInterval(window.signOutTimerInterval)
    this.removeDocumentEventListener()
    this.removeEventBusListener()
  },
  channels: {
    SignOutChannel: {
      connected() {
        console.log(
          '%c Connected to SignOutChannel from RemoteControlBar',
          'color: deepskyblue'
        )
      },
      received(data) {
        console.log('SignOutChannel data', data)
        data ? this.signOut() : null
      }
    }
  },
  methods: {
    restartSignOutTimer(time) {
      this.timer = time
      clearInterval(window.signOutTimerInterval)
      window.signOutTimerInterval = setInterval(() => {
        this.timer > 0
          ? this.timer--
          : (() => {
              clearInterval(window.signOutTimerInterval)
              this.signOut()
            })()
      }, 1000)
    },

    restartSignOutTimerIfCpAvailable() {
      this.cp
        ? this.restartSignOutTimer(this.$cronTimeToSeconds(this.cp.remoteSignOutEvery))
        : null
    },

    addDocumentEventListener() {
      document.addEventListener('click', this.refreshTokenViaWebsockets)
    },

    removeDocumentEventListener() {
      document.removeEventListener('click', this.refreshTokenViaWebsockets)
    },

    addEventBusListener() {
      eventBus.$on('refresh-token-via-websockets', this.refreshTokenViaWebsockets)
    },

    removeEventBusListener() {
      eventBus.$off('refresh-token-via-websockets', this.refreshTokenViaWebsockets)
    },

    signOut() {
      this.$blockUI()
      axios({
        method: 'delete',
        url: '/auth/remote_sign_out',
        headers: {
          common: {
            Authorization: `Bearer ${this.userToken}`
          }
        },
        data: {
          fingerprint: this.fingerprint,
          token: this.userToken
        }
      })
        .then((response) => {
          if (response.status == 204) {
            this.$store.commit('setUserToken', '')
            this.$store.commit('removeCp')
            this.$router.push('/qr')
          }
        })
        .catch((error) => {
          this.$errorHumanized(null, 'not authorized')
        })
        .finally(() => {
          this.$unblockUI()
          this.$store.commit('modal/closeAllModals')
        })
    },

    fetchCpWithRemoteData() {
      // INFO: QR5
      this.$blockUI()

      axios({
        method: 'get',
        url: `collection_points/${this.deviceId}/map`
      })
        .then((response) => {
          this.$store.commit('setCurrentCp', response.data)
        })
        .catch(() => {
          this.$errorHumanized(null, 'Provide correct device id')
        })
        .finally(() => {
          this.$unblockUI()
        })
    },

    subscribeToSignOutChannel(fingerprint) {
      this.$cable.subscribe({
        channel: 'SignOutChannel',
        remote_device_fingerprint: fingerprint
      })
    },

    refreshTokenViaWebsockets() {
      console.log('refresh-token-via-websockets')
      this.$cable.perform({
        channel: 'SignOutChannel',
        action: 'send_message',
        data: {
          content: this.userToken
        }
      })
      this.restartSignOutTimerIfCpAvailable()
    }
  }
}
</script>

<template lang="pug">
.bar
  .bar__inner
    .bar-address
      span.text-muted(v-if="cp") {{ cp.name }}, {{ cp.address }}
    .bar-timer {{ timer }}
    .bar-button
      button.btn.btn-sm.btn-primary.text-white(@click="signOut") {{ $t('signOut') }}
</template>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.bar {
  position: fixed;
  z-index: 10000;
  width: 100vw;
  background: #fff;
  height: 7rem;
}
.bar__inner {
  padding: 1rem;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid $gray-lighter;
  height: 100%;

  .bar-address {
    flex: 1;
  }

  .bar-timer {
    text-align: center;
    font-size: 3rem;
    width: 7rem;
    margin: 0rem 1rem;
    color: $danger;
  }
}
</style>
